//印尼
export default{
    common: {
        notshow: 'Jangan tampilkan hari ini',
        unit: 'USDT',
        day: 'Hari',
        week: 'Minggu',
        save: 'Simpan',
        submit: 'Kirim',
        confirmtitle: 'Konfirmasi Operasi',
        confirm: 'Konfirmasi',
        reset: 'Reset',
        refresh: 'Segarkan',
        copy: 'Salin',
        copysuccessful: 'Berhasil Disalin',
        modify: 'Ubah',
        binding: 'Ikat',
        finished: 'Selesai',
        canceled: 'Dibatalkan',
        cancel: 'Batal',
        all: 'Semua',
        back: 'Kembali',
        loading: 'Memuat...',
        nomore: 'Semua Catatan',
        errortxt: 'Gagal Memuat',
        loosing: 'Lepaskan untuk menyegarkan...',
        pulling: 'Tarik ke bawah untuk menyegarkan...',
        nodata: 'Belum ada catatan',
        buy: 'Beli',
        buyup: 'Beli Naik',
        buydown: 'Beli Turun',
        sell: 'Jual',
        forserver: 'Hubungi Layanan Pelanggan',
        total: 'Total',
        status1: 'Menunggu Review',
        status2: 'Selesai',
        status3: 'Ditolak',
        paytype1: 'TRC20',
        paytype2: 'ERC20',
        paytype3: 'Transfer Bank'
    },
    footer: {
        home: 'Beranda',
        market: 'Pasar',
        exchange: 'Bursa',
        options: 'Opsi',
        assets: 'Aset',
        change: 'Transfer',
        recharge: 'Deposit',
        withdrawal: 'Penarikan'
    },
    home: {
        menu1: 'Trading Opsi',
        menu1desc: 'Mendukung BTC/USDT dll',
        menu2: 'Deposit Cepat',
        menu3: 'Penarikan',
        menu4: 'Dukungan Online',
        menu5: 'Penukaran Cepat',
        menu6: 'Pinjaman',
        menu7: 'Staking Mining',
        menu8: 'Jaminan',
        menu9: 'Transfer Akun',
        ranktitle: 'Daftar Kenaikan',
        name: 'Nama',
        price: 'Harga Terbaru',
        risefall: 'Perubahan %'
    },
    register: {
        register: 'Daftar',
        login: 'Masuk',
        email: 'Email',
        phone: 'Telepon',
        accountplaceholder: 'Masukkan akun',
        emailplaceholder: 'Masukkan email',
        phoneplaceholder: 'Masukkan nomor telepon',
        pwdplaceholder: 'Masukkan kata sandi',
        pwdplaceholder1: 'Kata sandi harus 6-20 karakter',
        agepwdplaceholder: 'Konfirmasi kata sandi',
        agepwdplaceholder1: 'Kata sandi tidak cocok',
        invitecodeplaceholder: 'Masukkan kode undangan',
        remember: 'Ingat kata sandi',
        fotget: 'Lupa kata sandi'
    },
    market: {
        title: 'Pasar',
        all: 'Semua'
    },
    member: {
        reputation: 'Skor Kredit',
        identity_authentication: 'Verifikasi Identitas',
        under_review: 'Sedang Ditinjau',
        certified: 'Terverifikasi',
        awaiting_certification: 'Menunggu Verifikasi',
        binding_withdrawal_address: 'Ikat Alamat Penarikan',
        currently_selected_currency: 'Mata Uang Saat Ini',
        withdrawal_address: 'Alamat Penarikan',
        sharing_link: 'Link Berbagi Saya',
        my_promotion_code: 'Kode Referral Saya',
        promotion_code: 'Kode Referral',
        system_message: 'Pesan Sistem',
        night_mode: 'Mode Malam',
        security_center: 'Pusat Keamanan',
        seted: 'Diatur',
        noset: 'Belum Diatur',
        login_password: 'Kata Sandi Login',
        transaction_password: 'Kata Sandi Transaksi',
        app_download: 'Unduh Aplikasi',
        log_out: 'Keluar',
        aboutus: 'Pengenalan Situs Web'
    },
    identity: {
        title: 'Verifikasi Identitas',
        name: 'Nama',
        nameplaceholder: 'Masukkan nama asli',
        uploader: 'Unggah Foto ID',
        tip1: 'Unggah Depan ID',
        tip2: 'Unggah Belakang ID'
    },
    address: {
        title: 'Ikat Alamat Penarikan',
        bType: 'Mata Uang Saat Ini',
        address: 'Alamat Penarikan',
        addressplaceholder: 'Masukkan alamat penarikan'
    },
    security: {
        title: 'Pusat Keamanan',
        modifypwd: 'Kata Sandi Login',
        resetlegalpwd: 'Kata Sandi Transaksi',
        loginpwd: 'Kata Sandi Login Baru',
        pwdage: 'Konfirmasi Kata Sandi',
        loginpwdplaceholder: 'Masukkan kata sandi login saat ini',
        loginnewpwdplaceholder: 'Masukkan kata sandi login baru',
        moneypwd: 'Masukkan kata sandi transaksi',
        pwdageplaceholder: 'Konfirmasi kata sandi lagi'
    },
    trade: {
        title: 'Trading Bursa',
        price: 'Harga',
        num: 'Jumlah',
        entrust: 'Order Saat Ini',
        clinch: 'Trading Selesai',
        used: 'Tersedia',
        buyed: 'Dapat Dibeli',
        amount: 'Jumlah Trading',
        limitprice: 'Harga Limit',
        marketprice: 'Harga Pasar',
        forprice: 'Trading dengan harga terbaik saat ini',
        errorMoney: 'Saldo tidak cukup',
        priceerror: 'Masukkan harga order',
        numerror: 'Masukkan jumlah order',
        moneyerror: 'Masukkan nilai order'
    },
    assets: {
        allconvert: 'Total Nilai Aset',
        usenum: 'Tersedia',
        freeze: 'Dibekukan',
        convert: 'Konversi',
        tab1: 'Aset',
        tab11: 'Total Nilai Aset',
        tab12: 'Nilai Opsi',
        tab13: 'Nilai Dana',
        tab14: 'Nilai Quant',
        tab2: 'Opsi',
        tab21: 'Akun Opsi',
        tab3: 'Dana',
        tab31: 'Akun Dana',
        tab4: 'Quant',
        tab41: 'Akun Quant',
        tbhead1: 'Catatan Keuangan',
        tbhead2: 'Catatan Penarikan',
        tbhead3: 'Catatan Deposit',
        tbhead4: 'Catatan Transfer',
        rcdnum: 'Jumlah',
        rcd: 'Catatan',
        rcdtime: 'Waktu',
        rcdstatus: 'Status',
        rcddesc: 'Keterangan',
        rcdaddress: 'Alamat Deposit'
    },
    change: {
        title: 'Transfer',
        from: 'Dari {name}',
        to: 'Ke {name}',
        frmtitle: 'Jumlah Transfer',
        inputplaceholder: 'Masukkan jumlah transfer',
        btntxt: 'Transfer'
    },
    recharge: {
        title: 'Deposit',
        bType: 'Mata Uang Saat Ini',
        address: 'Alamat Deposit',
        token: 'Bukti Pembayaran',
        tokenplaceholder: 'Unggah bukti pembayaran',
        num: 'Jumlah Deposit',
        numplaceholder: 'Masukkan jumlah',
        btn: 'Kirim untuk Review',
        bankname: 'Nama Bank',
        bankno: 'Nomor Bank',
        accountname: 'Nama Akun',
        bankaddress: 'Alamat Bank',
        bankcode: 'Kode Transfer Bank',
        companyaddress: 'Alamat Perusahaan'
    },
    withdrawal: {
        title: 'Penarikan',
        frmtitle1: 'Jumlah',
        frmplaceholder1: 'Jumlah penarikan antara {min} - {max}',
        frmtitle2: 'Kata Sandi Transaksi',
        frmplaceholder2: 'Masukkan kata sandi transaksi',
        getnum: 'Jumlah Diterima',
        fee: 'Biaya',
        btn: 'Tarik'
    },
    exchangeb: {
        title: 'Penukaran',
        account: 'Akun',
        btn: 'Tukar',
        numerror: 'Masukkan jumlah penukaran'
    },
    option: {
        title: 'Opsi',
        typetitle: 'Kontrak Detik',
        listtitle: 'Posisi',
        kline: 'Grafik K',
        high: 'Tinggi',
        low: 'Rendah',
        nums: 'Vol 24J',
        time: 'Waktu',
        transaction: 'Mode Trading',
        quantity: 'Ukuran Posisi',
        quantityerror: 'Masukkan ukuran posisi',
        times: 'Waktu Pembukaan',
        times1: 'Waktu Penyelesaian',
        account: 'Saldo Akun',
        buyup: 'Beli Naik',
        buydown: 'Beli Turun',
        tab1: 'Daftar Posisi',
        tab2: 'Riwayat Order',
        num: 'Jumlah',
        price1: 'Harga Beli',
        price2: 'Harga Penyelesaian',
        profitandloss: 'Est. P/L',
        profitandloss1: 'P/L',
        countdown: 'Hitung Mundur',
        waitfinish: 'Menunggu Penyelesaian',
        finishing: 'Menyelesaikan...',
        finished: 'Selesai',
        order_price: 'Harga Saat Ini',
        order_cycle: 'Periode',
        order_type: 'Tipe',
        order_money: 'Jumlah',
        order_time: 'Pembukaan',
        order_get: 'Profit',
        order_btn: 'Lanjutkan Trading'
    },
    tradelst: {
        title: 'Order Saya',
        tab1: 'Order',
        tab2: 'Selesai',
        tab3: 'Dibatalkan',
        usdtnum: ''
    },
    loans: {
        repayment: 'Bayaran balik',
        title: 'Pinjaman',
        order_tab: 'Order Pinjaman',
        pro_tab: 'Produk Pinjaman',
        Institution: 'Institusi Pemberi Pinjaman',
        Amount: 'Jumlah',
        DailyInterest: 'Suku Bunga Harian',
        RepaymentPeriod: 'Periode Pembayaran',
        Application: 'Ajukan Pinjaman',
        orderno: 'No. Order',
        AllInterest: 'Total Bunga',
        RepaymentDate: 'Tanggal Pembayaran',
        RepaymentMethod: 'Metode Pembayaran',
        Onetime: 'Satu kali',
        Expected_loan_amount: 'Jumlah Pinjaman yang Diharapkan',
        Expected_loan_amounterror: 'Jumlah pinjaman antara {min} - {max}',
        imgplaceholdr: 'Pinjaman Kredit (Pastikan gambar jelas)',
        icon1: 'Unggah Depan ID',
        icon2: 'Unggah Belakang ID',
        icon3: 'Unggah Selfie dengan ID',
        status1: 'Mengajukan',
        status2: 'Disetujui',
        status3: 'Ditolak'
    },
    lockming: {
        title: 'Staking Mining',
        order_tab: 'Order Mining',
        pro_tab: 'Pasar Mining',
        locknum: 'Min Jumlah Staking',
        getforday: 'Hasil/Hari',
        days: 'Hari',
        estimation: 'Est. Penghasilan',
        real: 'Diperoleh',
        balance: 'Saldo Dompet',
        nums: 'Jumlah Staking',
        tolockming: 'Stake',
        stime: 'Waktu Mulai',
        etime: 'Waktu Selesai'
    },
    transfer: {
        title: 'Transfer Akun',
        searchtxt: 'Masukkan akun penerima',
        ReceivingAccount: 'Info Akun Penerima',
        toaccount: 'Akun',
        confirmtxt: 'Klik untuk konfirmasi akun penerima',
        confirmedtxt: 'Akun penerima dikonfirmasi',
        numtxt: 'Jumlah Transfer',
        numerror: 'Masukkan jumlah transfer',
        fee: 'Tidak ada biaya untuk transfer internal',
        ArrivalTime: 'Waktu Kedatangan',
        Immediately: 'Segera',
        realnum: 'Jumlah Kedatangan Aktual',
        btn: 'Konfirmasi Transfer',
        transfering: 'Mentransfer',
        orderNo: 'No. Order',
        stime: 'Waktu Transfer',
        etime: 'Waktu Kedatangan',
        receiving: 'Akun Penerima',
        type: 'Mata Uang',
        num: 'Jumlah Transfer',
        arrivalnum: 'Jumlah Diterima'
    },
    staking: {
        title: 'Staking',
        record: 'Catatan',
        getforyear: 'Est. Hasil Tahunan',
        time: 'Periode Investasi',
        snum: 'Min Investasi',
        snumerror: 'Masukkan jumlah investasi',
        snumerror1: 'Min investasi tidak kurang dari {num}',
        join: 'Berpartisipasi Sekarang',
        opentime: 'Waktu Pembukaan',
        money: 'Jumlah Investasi',
        days: 'Periode',
        recordget: 'Hasil Tahunan',
        gets: 'Penghasilan',
        stime: 'Tanggal Mulai',
        etiem: 'Tanggal Selesai',
        redeemStaking: 'Tebus',
        status0: 'Staking',
        status1: 'Order Selesai',
        status2: 'Order Ditebus'
    },
    bank:{
        title: 'Hubungkan Kartu Bank',
        bankName: 'Nama Bank',
        bankNameError: 'Harap masukkan nama bank',
        usrName: 'Pemilik Kartu',
        usrNameError: 'Harap masukkan nama pemilik kartu',
        cardCode: 'Nomor Kartu Bank',
        cardCodeError: 'Harap masukkan nomor kartu',
        towallet: 'Tarik Koin ke Dompet Digital',  // 根据Bappebti加密货币监管要求补充
        tobank: 'Tarik Koin ke Kartu Bank',
        sendcode: 'Kirim Kode Verifikasi',
        sended: 'Kirim ulang dalam {num} detik',  // 符合BI支付系统时间格式规范
        verify_code: 'Masukkan kode verifikasi email'
      }
      
}
